import React from 'react'

const ThankYouPage = ({ title, text, buttons, className }) => {
  return (
    <div className={'thank-you-page' + (className ? ' ' + className : '')}>
      <div className="thank-you-page__content">
        {title && <p className="thank-you-page__title">{title}</p>}
        {text && <div className="thank-you-page__text">{text}</div>}
        {buttons && buttons.length > 0 && <div className="thank-you-page__buttons">{buttons}</div>}
      </div>
    </div>
  )
}

export default React.memo(ThankYouPage)
